import api from '@/api/index.js'

const account_additional_details = {
  state: {
    loading: false,
    updating: false,
    data: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_ADDITIONAL_DETAILS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_ACCOUNT_ADDITIONAL_DETAILS_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_ACCOUNT_ADDITIONAL_DETAILS: (state, data) => {
      state.data = data
      state.loading = false
      state.updating = false
    },
    SET_ACCOUNT_ADDITIONAL_DETAILS_ERROR: (state, error) => {
      state.error = error
      state.loading = false
    },
  },

  actions: {
    LoadAccountAdditionalDetails({commit}, id) {
      commit('SET_ACCOUNT_ADDITIONAL_DETAILS', null)
      commit('SET_ACCOUNT_ADDITIONAL_DETAILS_ERROR', null)
      commit('SET_ACCOUNT_ADDITIONAL_DETAILS_LOADING', true)
      return api.get(`accounts/${id}/additional-details`)
        .then((response) => {
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    CreateAccountAdditionalDetails({commit}, payload) {
      commit('SET_ACCOUNT_ADDITIONAL_DETAILS_ERROR', null)
      commit('SET_ERROR', null)
      commit('SET_ACCOUNT_ADDITIONAL_DETAILS_UPDATING', true)
      return api.post(`accounts/${payload.accountId}/additional-details`, payload.data)
        .then((response) => {
          // NOTE: no need to call `commit('SET_ACCOUNT_ADDITIONAL_DETAILS', response.body)` cause next step will call LoadAccount with all the details.
          // Such call causes not refreshing UI.
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS_ERROR', error)
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS_UPDATING', false);
        })
    },
    UpdateAccountAdditionalDetails({commit}, payload) {
      commit('SET_ACCOUNT_ADDITIONAL_DETAILS_ERROR', null)
      commit('SET_ERROR', null)
      commit('SET_ACCOUNT_ADDITIONAL_DETAILS_UPDATING', true)
      return api.put(`accounts/${payload.accountId}/additional-details/${payload.id}`, payload.data)
        .then((response) => {
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS', response.body)
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS_ERROR', error)
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS_UPDATING', false);
        })
    },
    DeleteAccountAdditionalDetails({commit}, payload) {
      commit('SET_ACCOUNT_ADDITIONAL_DETAILS_ERROR', null)
      commit('SET_ERROR', null)
      commit('SET_ACCOUNT_ADDITIONAL_DETAILS_UPDATING', true)
      return api.delete(`accounts/${payload.accountId}/additional-details/${payload.id}`)
        .then((response) => {
          // NOTE: no need to call `commit('SET_ACCOUNT_ADDITIONAL_DETAILS', null)` cause next step will call LoadAccount with all the details.
          // Such call causes not refreshing UI.
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS_ERROR', error)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_ACCOUNT_ADDITIONAL_DETAILS_UPDATING', false);
        })
    }
  },
}

export default account_additional_details
